import { appStorage } from '../lib/betaStorage'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export type ProfileViewMode = 'visual' | 'compact'

export function useProfileViewMode(userId: string, namespace = 'shared') {
  const key = `schub.profileView.${namespace}.${userId}`
  const [viewMode, setViewMode] = useState<ProfileViewMode>(() => {
    try { return appStorage.getItem(key) === 'compact' ? 'compact' : 'visual' } catch { return 'visual' }
  })

  useEffect(() => {
    try { appStorage.setItem(key, viewMode) } catch { /* ignore storage failures */ }
  }, [key, viewMode])

  return [viewMode, setViewMode] as const
}

export function ProfileViewBar({
  viewMode,
  onChange,
  profileTo = '/profile',
}: {
  viewMode: ProfileViewMode
  onChange: (mode: ProfileViewMode) => void
  profileTo?: string
}) {
  return (
    <div className="mt-3 flex items-center justify-between gap-3" data-profile-view-bar="canonical-mark-v1">
      <Link to={profileTo} className="text-[13px] font-bold text-[#607f9e]">My profile</Link>
      <div className="flex rounded-[14px] border border-[#d6e2ec] bg-[#f8fafc] p-1" aria-label="Profile view">
        <button onClick={() => onChange('visual')} className={`rounded-[10px] px-3 py-2 text-[12px] font-bold transition ${viewMode === 'visual' ? 'bg-[#7f9fbd] text-white shadow-sm' : 'text-[#71808f]'}`}>Visual</button>
        <button onClick={() => onChange('compact')} className={`rounded-[10px] px-3 py-2 text-[12px] font-bold transition ${viewMode === 'compact' ? 'bg-[#7f9fbd] text-white shadow-sm' : 'text-[#71808f]'}`}>Compact</button>
      </div>
    </div>
  )
}

